<table border="0" cellpadding="4" cellspacing="4" style="width: 99%; margin: 0 auto;">
  <tbody>
    <tr>
      <td colspan="2">
        <div *ngIf="error" id="errors">
          There were some errors:
          <ul>
            <li [innerHTML]="error"></li>
          </ul>
        </div>
        <div *ngIf="eventCode === ''" class="text-center">
          <strong>Please indicate if you would like to register for a live or virtual <i>SHARE Nurse Training</i> Speaker Program.</strong>
          <br><br>
          <input style="font-weight:bold;" id="live_button" type="button" class="btn btn-primary" value="LIVE" (click)="clickedEvent('live_button')"> &nbsp;&nbsp;
          <input style="font-weight:bold;" id="virtual_button" type="button" class="btn btn-primary ml-40" value="VIRTUAL" (click)="clickedEvent('virtual_button')"> 
        </div>
        <br>
        <form id="dev-reg-form" (ngSubmit)="onSubmitCode(); $event.preventDefault()">
          <div id="registration-form" [style.display]="selectedEventType === 'virtual' ? 'block' : 'none'">
            <div class="text-center mb-10"> 
              <strong id="show-vir-statement" [style.display]="selectedEventType === 'virtual' ? 'block' : 'none'">Please indicate the program for which you would like to register. The program number can be found on the invitation.</strong>
            </div>
            <div class="text-center">
              <strong>Program Number: </strong>
              <input style="line-height: 1.9; border-radius: 4px;" placeholder="(eg, S123)" type="text" name="code" size="17" [(ngModel)]="eventCode" required/> &nbsp;
              <input class="btn btn-primary" style="font-weight: bold;" type="submit" value="Submit" />
            </div>
          </div>
        </form>
      </td>
    </tr>

    <tr>
      <td colspan="2">
        <div id="registration-form-live" class="text-center" [style.display]="selectedEventType === 'live' ? 'block' : 'none'">
          <form id="dev-reg-form-live" (ngSubmit)="onSubmitCode(); $event.preventDefault()">
            <strong>Please indicate the program for which you would like to register. The program number can be found on the invitation.</strong> 
            <br><br>
            
            <div class="form-group">
              <strong>Program Number: </strong>
              <input placeholder="(eg, S123)" type="text" name="code" size="17" [(ngModel)]="eventCode" required /> <br />
            </div>

            <div class="form-group">
              <strong>State: </strong>
              <select name="state" [(ngModel)]="state">
                <option value="">Select State</option>
                <option *ngFor="let stateOption of stateOptions" [value]="stateOption">{{ stateOption }}</option>
              </select> <br> <br>
            </div>

            <input class="btn btn-primary" type="submit" style="font-weight: bold" value="Submit" />
          </form>
        </div>

        <br>
        <p>
          <i>
            As of January 1, 2022, PhRMA Code prohibits its members from providing alcoholic beverages at speaker programs, if applicable. Additionally, the wait staff cannot take your order for alcohol. You are, however, welcome to purchase your own drink at the bar and bring it into the meeting room. We appreciate your understanding.
          </i>
        </p>
      </td>
    </tr>
  </tbody>
</table>
